import { render, staticRenderFns } from "./CardDropdown.vue?vue&type=template&id=787d5cd5&scoped=true"
import script from "./CardDropdown.vue?vue&type=script&lang=js"
export * from "./CardDropdown.vue?vue&type=script&lang=js"
import style0 from "./CardDropdown.vue?vue&type=style&index=0&id=787d5cd5&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "787d5cd5",
  null
  
)

export default component.exports